module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"closedForSummer":"Intersolia Denmark office will be closed for summer holiday throughout weeks 28 & 29","closedForChristmas":"Merry Christmas and a Happy New Year! We are closed from Dec 24 to Jan 3"}}')
  delete Component.options._Ctor
}
